import React, {Component} from 'react';
import {connect} from 'react-redux';
import ManageBrokerAccount from "../../components/ManageBrokerAccount/manageBrokerAccount";
import {
    changeBroker,
    changeBrokerPassword,
    changeBrokerState, closeBrokerPasswordModal,
    getBrokerById, openBrokerPasswordModal,
    updateBrokerById, updateBrokerPassword
} from "../../actions/broker";
import {isEmail, isPhone} from "../../helpers/functions";

class ManageBrokerAccountHOC extends Component{

    _submitChangedPassword = (evt) => {
        evt.preventDefault();
        this.props.updateBrokerPassword({
            sendBody: {
                oldPassword: this.props.passwordForm.password,
                newPassword: this.props.passwordForm.newPassword,
                reNewPassword: this.props.passwordForm.retypedNewPassword,
                userId: this.props.broker.userId,
            }
        })
    };

    _changePasswordForm = (key, value) => {
        this.props.changeBrokerPassword({
            key: key,
            value: value
        })
    };

    componentDidMount(){
        this.props.getBrokerById({id: this.props.userId})
    }

    validateForm = () => {
        const errors = [];
        if(this.props.broker.email && !isEmail(this.props.broker.email)){
            errors.push('Email is not valid.')
        }
        if(this.props.broker.ccEmailAddress && !isEmail(this.props.broker.ccEmailAddress)){
            errors.push('CC Email is not valid.')
        }
        if(this.props.broker.telephone1 && !isPhone(this.props.broker.telephone1)){
            errors.push('Telephone Number 1 is not valid.')
        }
        if(this.props.broker.telephone2 && !isPhone(this.props.broker.telephone2)){
            errors.push('Telephone Number 2 is not valid.')
        }
        return errors;
    };

    _handleSubmit = (evt) => {
        evt.preventDefault();
        const errors = this.validateForm();
        if(errors.length > 0){
            this.props.changeBrokerState({
                key: 'formErrors',
                value: errors
            });
            return false
        }
        const sendBody = {
            id: this.props.broker.id,
            userId: this.props.broker.userId,
            forename: this.props.broker.forename,
            surname: this.props.broker.surname,
            telephone1: this.props.broker.telephone1,
            telephone1Description: this.props.broker.telephone1Description,
            telephone2: this.props.broker.telephone2,
            telephone2Description: this.props.broker.telephone2Description
        };
        this.props.updateBrokerById({
            sendBody: sendBody
        })
    };

    render(){
        return(
            <ManageBrokerAccount
                {...this.props}
                _handleSubmit={this._handleSubmit}
                openBrokerPasswordModal={this.props.openBrokerPasswordModal}
                closeBrokerPasswordModal={this.props.closeBrokerPasswordModal}
                _changePasswordForm={this._changePasswordForm}
                _submitChangedPassword={this._submitChangedPassword}
            />
        )
    }
};

const mapStateToProps = (state) => {
    return {
        broker: state.broker.broker,
        userId: state.user.loggedInUser.id,
        loading: state.broker.patching,
        fetchingBroker: state.broker.fetching,
        formErrors: state.broker.formErrors,
        formSuccessMsg: state.broker.formSuccessMsg,
        isChangePasswordModalOpen: state.broker.isChangePasswordModalOpen,
        passwordForm: state.broker.passwordForm,
        updatingPassword: state.broker.updatingPassword,
        updatePasswordError: state.broker.updatePasswordError,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBrokerById: (payload) => {
            dispatch(getBrokerById(payload))
        },
        changeBroker: (payload) => {
            dispatch(changeBroker(payload))
        },
        updateBrokerById: (payload) => {
            dispatch(updateBrokerById(payload))
        },
        changeBrokerState: (payload) => {
            dispatch(changeBrokerState(payload))
        },
        changeBrokerPassword: (payload) => {
            dispatch(changeBrokerPassword(payload))
        },
        openBrokerPasswordModal: (payload) => {
            dispatch(openBrokerPasswordModal(payload))
        },
        closeBrokerPasswordModal: (payload) => {
            dispatch(closeBrokerPasswordModal(payload))
        },
        updateBrokerPassword: (payload) => {
            dispatch(updateBrokerPassword(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageBrokerAccountHOC)